/* eslint-disable */
export default {
  attachFiles: 'Anexar arquivo',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
